import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  leftIcon?: React.ReactNode;
}
export function Input({
  label,
  error,
  leftIcon,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-527">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-528">
          {label}
        </label>}
      <div className="relative" data-id="element-529">
        {leftIcon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500" data-id="element-530">
            {leftIcon}
          </div>}
        <input id={inputId} className={`
            block w-full rounded-lg border-gray-300 shadow-sm 
            focus:border-[#FFD700] focus:ring-[#FFD700] sm:text-sm py-3
            disabled:bg-gray-50 disabled:text-gray-500
            ${leftIcon ? 'pl-10' : 'pl-3'}
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300'}
            ${className}
          `} {...props} data-id="element-531" />
      </div>
      {error && <p className="mt-1 text-sm text-red-600" role="alert" data-id="element-532">
          {error}
        </p>}
    </div>;
}